import { useState } from "react";
import "./MostFavorite.css";
import leaf3 from "../../Images/leaf3.png";

const MostFavorite = () => {
  return (
    <div className="overflow-hidden relative">
      {/* ✅ Decorative leaf image with descriptive alt */}
      <img
        className="w-[120px] lg:w-[auto] hidden sm:block absolute bottom-[0px] lg:bottom-[180px] left-[-30px] lg:left-[-60px] fa-rotate-90"
        alt="Leaf decoration for Clariss Bangladesh section"
        src={leaf3}
        loading="lazy"
      />

      <div
        className={`flex flex-col px-[10px] items-center sm:px-[20px] lg:px-[0px] lg:w-[90%] mx-auto ${
          window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"
        }`}
      >
        {/* ✅ SEO-friendly heading for the video section */}
        <h3 className="sr-only">
          Most Favorite Clariss Beauty Products – Watch Our YouTube Video
        </h3>

        {/* ✅ Accessible YouTube iframe */}
        <iframe
          width="1300"
          height="740"
          className="responsive-iframe"
          src="https://www.youtube.com/embed/a5iZg8PrkBg?autoplay=1&playlist=BiYZzHcUD-A&loop=1"
          title="Most Favorite Clariss Beauty Products – YouTube Video"
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>

        {/* ✅ Optional SEO text for context (hidden visually but improves crawlability) */}
        <p className="sr-only">
          Discover Clariss Bangladesh’s most favorite beauty products in this
          featured YouTube video. Learn more about skincare, haircare, and
          natural beauty essentials.
        </p>
      </div>
    </div>
  );
};

export default MostFavorite;
